import type {ItemBorderObject} from '@PosterWhiteboard/classes/item-border.types';
import {BorderType} from '@PosterWhiteboard/classes/item-border.types';
import type {RGBA} from '@Utils/color.util';
import type {DeepPartial} from '@/global';

/**
 * A text item's box border lives in the base `border` fields every item carries
 * (`solidBorderType` / `solidBorderColor` / `solidBorderThickness`, thickness in canvas pixels),
 * the way the QR container border does. For text, the border is on only while the type is not
 * NONE AND the thickness is above 0; the Background block's thickness slider is the one control,
 * so 0 switches the type off and any other value switches it on as a rectangle (text has its own
 * roundness, so the rounded type is never used).
 */
export const isTextBoxBorderOn = (border: ItemBorderObject): boolean => {
  return border.solidBorderType !== BorderType.NONE && border.solidBorderThickness > 0;
};

/** The thickness the slider shows: 0 whenever the border is off, whatever thickness is stored. */
export const getTextBoxBorderWidth = (border: ItemBorderObject): number => {
  return isTextBoxBorderOn(border) ? border.solidBorderThickness : 0;
};

export const TEXT_BOX_BORDER_OFF: DeepPartial<ItemBorderObject> = {solidBorderType: BorderType.NONE, solidBorderThickness: 0};

export const getTextBoxBorderWidthChange = (width: number): DeepPartial<ItemBorderObject> => {
  if (width <= 0) {
    return TEXT_BOX_BORDER_OFF;
  }
  return {solidBorderType: BorderType.RECTANGLE_BORDER, solidBorderThickness: width};
};

export const getTextBoxBorderColorChange = (color: RGBA): DeepPartial<ItemBorderObject> => {
  return {solidBorderColor: color};
};
